import type { AmbassadorClass } from "../types";

export function AmbassadorClassCard({
  ambassadorClass
}: {
  ambassadorClass: AmbassadorClass;
}) {
  const Icon = ambassadorClass.icon;

  return (
    <details className="class-card">
      <summary className="class-card__summary">
        <div className="class-card__summary-copy">
          <div className="class-card__icon">
            <Icon size={24} />
          </div>
          <div>
            <h3>{ambassadorClass.title}</h3>
            <p>{ambassadorClass.summary}</p>
          </div>
        </div>
        <span className="class-card__toggle">
          <span className="class-card__open-label">Open</span>
          <span className="class-card__close-label">Close</span>
        </span>
      </summary>

      <div className="class-card__body">
        <Panel title="Commission basis" items={ambassadorClass.commissionBasis} tone="green" />
        <Panel title="Available surfaces" items={ambassadorClass.activeSurfaces} tone="cyan" />
        <Panel title="Planned integrations" items={ambassadorClass.plannedSurfaces} tone="amber" />
        <Panel title="Training areas" items={ambassadorClass.training} tone="violet" />
      </div>
    </details>
  );
}

function Panel({
  title,
  items,
  tone
}: {
  title: string;
  items: string[];
  tone: "green" | "cyan" | "amber" | "violet";
}) {
  return (
    <section className={`class-panel class-panel--${tone}`}>
      <h4>{title}</h4>
      <ul>
        {items.map((item) => (
          <li key={item}>
            <span aria-hidden="true" />
            {item}
          </li>
        ))}
      </ul>
    </section>
  );
}
